import { ExpandMore } from '@mui/icons-material';
import { ButtonBase, styled } from '@mui/material';

export const WaterfallSearchableCellSelectTrigger = styled(ButtonBase)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 'inherit',
  fontWeight: 400,
  height: '100%',
  justifyContent: 'space-between',
  left: 0,
  minHeight: 28,
  padding: '2px 4px',
  position: 'absolute',
  textAlign: 'left',
  top: 0,
  width: '100%',
}));

export const WaterfallSearchableCellSelectValue = styled('span')({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const WaterfallSearchableCellSelectIcon = styled(ExpandMore)({
  flex: '0 0 auto',
  fontSize: '1rem',
});
